<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="deliveryPointSelected"
    :clearable="!unclearable"
    :items="deliveryPointItems"
    :loading="deliveryPointLoading"
    :search-input.sync="deliveryPointSearch"
    item-text="name"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('DeliveryPoint.title')"
    return-object
    :single-line="singleLine"
    :dense="dense"
    :hide-details="hideDetails"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
  ></v-autocomplete>
</template>

<script>
import DeliveryPoints from "@/api/delivery_points";


export default {
  name: "SearcherDeliveryPoint",

  props: {
    value: [Object, Array],
    stockDistrict: Object,
    stockDistricts: Array,
    noLabel: Boolean,
    label: String,
    singleLine: Boolean,
    dense: Boolean,
    hideDetails: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
  },

  computed: {
    deliveryPointItems() {
      return this.deliveryPoints.map((deliveryPoint) => {
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == deliveryPoint.id
            )
          : false;
        return Object.assign({}, deliveryPoint, { disabled });
      });
    },
  },

  data: () => ({
    deliveryPoints: [],
    deliveryPointLoading: false,
    deliveryPointSearch: "",
    deliveryPointSelected: null,
  }),

  mounted() {
    this.deliveryPointLoading = true;
    DeliveryPoints.fetchAll()
      .then(
        function (response) {
          if (response.data.status.isOK()) {
            this.deliveryPoints = response.data.delivery_points;
          }
          this.deliveryPointLoading = false;
        }.bind(this)
      )
      .catch(
        function () {
          this.deliveryPointLoading = false;
        }.bind(this)
      );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.unclearable && !this.value && this.deliveryPoints) {
          this.deliveryPointSelected = this.deliveryPoints[0];
        } else {
          this.deliveryPointSelected = this.value;
        }
      },
    },

    deliveryPointSelected: {
      handler() {
        this.$emit("input", this.deliveryPointSelected);
      },
    },
  },
};
</script>